import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#0B1C30] text-white mt-20" data-testid="site-footer">
      <div className="tk-container py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-md bg-white flex items-center justify-center">
              <span className="text-[#0B1C30] text-sm font-bold">tk</span>
            </div>
            <span className="font-semibold text-lg tracking-tight">tekkdeler.no</span>
          </div>
          <p className="text-sm text-slate-300 max-w-xs leading-relaxed">
            Norges nettbutikk og verkstedplattform for Apple-reparasjoner. Trygt. Lokalt. Raskt.
          </p>
        </div>

        <div>
          <h4 className="tk-overline mb-4 text-slate-400">Butikk</h4>
          <ul className="space-y-2 text-sm text-slate-200">
            <li>iPhone-deler</li>
            <li>iPad-deler</li>
            <li>MacBook-deler</li>
            <li>iMac-deler</li>
          </ul>
        </div>

        <div>
          <h4 className="tk-overline mb-4 text-slate-400">Verksteder</h4>
          <ul className="space-y-2 text-sm text-slate-200">
            <li>Vi er i vekst og åpner nye repair points</li>
            <li className="pt-2">
              <Link to="/bli-verksted" className="text-[#4A7C59] hover:text-white" data-testid="footer-apply-link">
                Bli partner-verksted →
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="tk-overline mb-4 text-slate-400">Kontakt</h4>
          <ul className="space-y-2 text-sm text-slate-200">
            <li>
              <a href="mailto:post@tekkdeler.no" className="hover:text-white" data-testid="footer-email">
                post@tekkdeler.no
              </a>
            </li>
            <li>
              <a href="tel:+4792563712" className="hover:text-white" data-testid="footer-phone">
                +47 92 56 37 12
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="tk-container py-6 text-xs text-slate-400 flex justify-between">
          <span>© {new Date().getFullYear()} Tekkdeler AS — Org.nr 999 999 999</span>
          <span>Betaling med Stripe og Vipps. Levering med Bring.</span>
        </div>
      </div>
    </footer>
  );
}
